import Box from '@mui/material/Box';
import {
  ConfirmModal,
  ConfirmModalDescription,
  type ConfirmModalProps,
  ConfirmModalTitle,
} from 'components/ui/modals/ConfirmModal/index.js';

interface ErrorModalProps {
  open: boolean;
  onClose: VoidFunction;
  errors: string[];
  actions?: ConfirmModalProps['actions'];
}

export const ErrorModal = ({ errors, open, onClose, actions }: ErrorModalProps) => {
  return (
    <ConfirmModal
      open={open}
      actions={[
        {
          title: 'Close',
          buttonProps: {
            color: 'secondary',
            variant: 'outlined',
          },
          onClick: onClose,
        },
        ...(actions || []),
      ]}
    >
      <ConfirmModalTitle data-sentry-unmask>Error in the Form</ConfirmModalTitle>
      <Box display="flex" flexDirection="column" data-sentry-unmask>
        <ConfirmModalDescription
          style={{
            fontWeight: 600,
            fontSize: 16,
            marginBottom: 7,
            textAlign: 'left',
          }}
        >
          In order to submit the form, the following fields needs to be filled:
        </ConfirmModalDescription>
        <ol style={{ padding: 0 }}>
          {errors.map(e => (
            <li key={e}>
              <ConfirmModalDescription style={{ textAlign: 'left' }}>
                {e}
              </ConfirmModalDescription>
            </li>
          ))}
        </ol>
      </Box>
    </ConfirmModal>
  );
};
